module.exports = __webpack_public_path__ + "media/images/front/toplogo-e7293b0e020094c73900e525e722620d.png";